import { checkStatus, handleError } from '../../utils/api';
import { getAuthTokenAsync } from '../../utils/authToken';
import { ValidateUser } from '../../interfaces/login';
import {
  UNEXPECTED_ERROR,
  DATA_REQUIRED,
  INCORRECT_DATA,
  TOO_MANY_REQUESTS,
} from '../../constants/errors';
import apiFetch from '../core/apiFetch';
import { mapUser } from './helpers';

export interface AccountRecoveryProps {
  firstName: string;
  lastName: string;
  birthdate: string;
}

interface Response {
  users?: ValidateUser[];
  error?: {
    code: string;
    message: string[];
  };
}

const accountRecoveryAsync = async ({
  firstName,
  lastName,
  birthdate,
}: AccountRecoveryProps): Promise<Response> => {
  try {
    const q = `first_name=${encodeURIComponent(
      firstName
    )}&last_name=${encodeURIComponent(lastName)}&birthdate=${encodeURIComponent(
      birthdate
    )}`;
    const url = `api/v2/validate_user/account_recovery?${q}`;
    const authToken = await getAuthTokenAsync();
    const resp = await apiFetch(authToken, url, { method: 'GET' });

    await checkStatus(resp);

    const { users } = await resp.json();
    return { users: users.map((user) => mapUser(user)) };
  } catch (error) {
    const { message, response } = error;

    if (response?.status === 400) {
      const payload = await response.json();
      return {
        error: {
          code: DATA_REQUIRED,
          message: payload.errors || [],
        },
      };
    }

    if (response?.status === 401) {
      const payload = await response.json();
      return {
        error: {
          code: INCORRECT_DATA,
          message: payload.errors || [],
        },
      };
    }

    if (response?.status === 429) {
      return {
        error: {
          code: TOO_MANY_REQUESTS,
          message: response?.statusText || [],
        },
      };
    }

    handleError('unexpected status - validate user', error);
    return {
      error: {
        code: UNEXPECTED_ERROR,
        message: [message],
      },
    };
  }
};

export default accountRecoveryAsync;
